module.exports = __webpack_public_path__ + "img/677.44ddb93c.jpg";